import React, { useEffect, useState } from 'react'
import GenericFormHeaderComponent from '../../../genericComponents/forms/GenericFormHeaderComponent'
import { convertCamelCase } from '../../../helper/genericFunction';
import { Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler, handleApiChange } from '../../../helper/apiHelperFunctions';
import GenericSpinnerLoader from '../../../loaders/GenericSpinnerLoader';
import { parseJwt } from '../../../helper/genericFunction';
import NoDataFound from '../../../genericComponents/NoDataFound';
import Icons from '../../../assets/icons';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import ImageUpload from '../create/product/ImageUpload';
import GenericViewDetailsComponent from '../../../genericComponents/viewDetails/GenericViewDetailsComponent';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { getPermissionKey } from '../../../helper/permissions';
import { HandCoins } from 'lucide-react';
import GenericInput from '../../../genericComponents/input/GenericInputComponent';
import CopyContentGenericComponent from '../../../genericComponents/CopyContentGenericComponent';

const ViewProductDetails = (props) => {
    const uType = parseJwt(sessionStorage.getItem('token')).uType?.toUpperCase() || "ENT";
    const {
        closeModal,
        viewPageType = "product",
        selectedData = {},
        permissionsObj = null
    } = props;

    const displayKey = `isDisplay${uType == "ENT" ? "Retailer" : "Vendor"}`

    const dispatch = useDispatch();
    const getProductDetailData = useSelector(state => state?.digicatStore?.getProductDetailData);
    const loadFabricData = useSelector(state => state?.digicatStore?.loadFabricData);
    const loadCostsheetData = useSelector(state => state?.digicatStore?.loadCostsheetData);
    const getDigicatFormSettingsData = useSelector(state => state?.administrationStore?.getDigicatFormSettingsData);
    const getProductDetailCustomData = useSelector(state => state?.digicatStore?.getProductDetailCustomData)
    const generalStore = useSelector((state) => state.generalStore);

    // State : To store the current tab
    const [currentTab, setCurrentTab] = useState(viewPageType);
    const [tableData, setTableData] = useState(null);
    const [formSettings, setFormSettings] = useState({});

    // State: To store the current expanded fabric data
    const [expandedFabric, setExpandedFabric] = useState(null);
    const [fabricFocusedRow, setFabricFocusedRow] = useState(null);

    // State : To store the images data
    const [imagesData, setImagesData] = useState({});
    const [responseData, setResponseData] = useState(null);

    // Custom Attributes Tab Headers - 
    const [headersData, setHeadersData] = useState({});
    const [headersType, setHeadersType] = useState({});

    const [currentCostSheet, setCurrentCostSheet] = useState(null);

    // handle : the repsonse of the product details api for the product tab
    useEffect(() => {
        if (getProductDetailData?.isSuccess) {
            setTableData(getProductDetailData?.data?.resource?.data || {});
            setImagesData(updateMediaData(getProductDetailData?.data?.resource?.data || {}))
        }
    }, [getProductDetailData?.isSuccess])

    const constructJson = (arr, keyToStringify) => {
        return arr.map(obj => {
            let newObj = { ...obj };
            if (obj[keyToStringify] !== undefined) {
                newObj[keyToStringify] = JSON.stringify(obj[keyToStringify]);
            }
            return newObj;
        });
    }

    // Handle the response of the fabric details api
    useEffect(() => {
        if (loadFabricData?.isSuccess) {
            let data = constructJson(loadFabricData?.data?.resource, "constructionJson");
            setTableData(data || []);
            if (loadFabricData?.data?.resource?.length > 0) {
                setFabricFocusedRow(data?.[0]);
            }
        }
    }, [loadFabricData?.isSuccess])

    useEffect(() => {
        if (getProductDetailCustomData?.isSuccess) {
            setTableData(getProductDetailCustomData?.data?.resource?.data || []);
            setImagesData(updateMediaData(getProductDetailData?.data?.resource?.data || {}))
        }

        if (generalStore?.getHeadersData?.isSuccess && generalStore?.getHeadersData?.data?.basedOn == "details") {
            let headersTypedata = Object.keys(generalStore?.getHeadersData?.data?.resource?.["Custom Headers"] || {})?.length > 0 ? "Custom Headers" : "Default Headers";
            setHeadersData(generalStore?.getHeadersData?.data?.resource || {})
            setHeadersType(headersTypedata)
        }
    }, [getProductDetailCustomData?.isSuccess, generalStore?.getHeadersData?.isSuccess])

    // Handle : The response of the costsheet details api
    useEffect(() => {
        if (loadCostsheetData?.isSuccess) {

            let data = ["DRAFTED", "SUBMITTED", "REQUESTED"]?.includes(props.activeTab) ? loadCostsheetData?.data?.resource?.[0] : loadCostsheetData?.data?.resource?.find(item => item?.costSheetNo === selectedData?.costSheetNo);
            setCurrentCostSheet(data);
            setTableData(data || []);
            setResponseData(loadCostsheetData?.data?.resource || {});
        }
    }, [loadCostsheetData?.isSuccess])

    console.log("tableData", tableData);
    useEffect(() => {
        if (getDigicatFormSettingsData?.isSuccess) {
            setFormSettings(getDigicatFormSettingsData?.data?.resource || {});
        }
    }, [getDigicatFormSettingsData?.isSuccess])

    useEffect(() => {
        getTableData();
    }, [currentTab])

    // Whenever the focused fabric row changes then update the fabric image
    useEffect(() => {
        setImagesData(updateMediaData(fabricFocusedRow))
    }, [fabricFocusedRow])

    // Function : To update the media data and set the media data inside the state
    const updateMediaData = (data, updatedMediaData = {}) => {
        switch (currentTab) {
            case "product": {
                let keys = ["imageUrlFront", "imageUrlBack", "imageUrlSide", "imageUrlDetailed", "imageUrlLook", "videoUrl", "rawImage1", "rawImage2", "pdfUrl", "teckPackUrl"];
                keys?.map(key => {
                    if (data?.[key]) {
                        updatedMediaData[key] = {
                            "url": data?.[key != "videoUrl" ? key == "teckPackUrl" ? "teckPack" : key == "pdfUrl" ? "pdf" : `${key}Url` : "video"] || "",
                            "filePath": data?.[key]
                        }
                    }
                })
                break;
            }
            case "fabric": {
                ["fabricImage"]?.map(key => {
                    if (data?.[key]) {
                        updatedMediaData[key] = {
                            "url": data?.[`${key}Url`] || "",
                            "filePath": data?.[key]
                        }
                    }
                })
            }
        }

        return updatedMediaData;
    }

    // Funcion : To render the header componernt
    const renderHeaderComponent = () => {
        return <GenericFormHeaderComponent
            label={{
                "contentPrimary": () => <div className='mb-2 flex items-center gap-2'>
                    <h4 className='!mb-0'>{convertCamelCase(viewPageType)} Details</h4>
                    {viewPageType === 'costsheet' && <div className='px-2.5 py-1 bg-[#F0F3F6] rounded-full'>
                        <h2 className='text-xs font-semibold text-[#67768E] mb-0'>Cost Sheet No : {tableData?.costSheetNo || '-'}</h2>
                    </div>}
                </div>,
                "contentSecondry": `View complete ${viewPageType} details for selected ${viewPageType}.`
            }}
            closeModal={closeModal}
        />
    }

    const getTableData = () => {
        switch (currentTab) {
            case "product": {
                dispatchHandler(dispatch, "getProductDetailRequest", { "productId": selectedData?.productId }, permissionsObj ?? getPermissionKey("purchase", "product", "copy"));
                break;
            }
            case "fabric": {
                dispatchHandler(dispatch, "loadFabricRequest", {
                    "dataValue": viewPageType != "product" ? selectedData?.fabricCode || "" : selectedData?.productId || "",
                    "isGetProductFabric": viewPageType == "product" ? true : false,
                }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))
                break;
            }
            case "costsheet": {
                dispatchHandler(dispatch, "loadCostsheetRequest", {
                    "dataValue": viewPageType != "product" ? selectedData?.costSheetNo || "" : selectedData?.productId || "",
                    "isProductCostSheet": viewPageType == "product" ? true : false,
                }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))
                break;
            }
            case "customAttributes": {
                dispatchHandler(dispatch, "getProductDetailCustomRequest", {
                    "id": selectedData?.id || "",
                }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))
                handleApiChange(dispatch, 'getHeadersRequest', { displayName: "PRODUCT_LIBRARY_DETAIL_CHINA", basedOn: "details" }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))
            }
        }
        let payloadKey = {
            "product": "productCatalogue",
            "fabric": "fabric",
            "costsheet": "costSheet",
        }
        if (currentTab !== "customAttributes") {
            dispatchHandler(dispatch, "getDigicatFormSettingsRequest", {
                type: payloadKey?.[currentTab] || ""
            }, permissionsObj ?? getPermissionKey("purchase", "product", "view"))
        }
    }

    // Function : To render the details of the product;
    const renderDetails = () => {

        let isLoading = {
            "product": getProductDetailData?.isLoading,
            "fabric": loadFabricData?.isLoading,
            "costsheet": loadCostsheetData?.isLoading,
            "customAttributes": getProductDetailCustomData?.isLoading,
        }

        if (isLoading?.[currentTab] || getDigicatFormSettingsData?.isLoading) {
            return <div className='h-[calc(100%-100px)] w-full flex items-center justify-center'><GenericSpinnerLoader /></div>
        }

        switch (currentTab) {
            case "product": {
                return renderProductDetails();
            }
            case "fabric": {
                return renderFabricDetails();
            }
            case "costsheet": {
                return renderCostsheetDetails()
            }
            case "customAttributes": {
                return renderCustomAttributes()
            }
        }
    }

    const isDisplayKey = (key) => {
        // console.log("jey", formSettings, key);
        return formSettings?.[key]?.[displayKey] == 1;
    }

    // State : To check if the keys is amount
    const isAmount = (key) => {
        if ((responseData?.[0]?.tradeDiscountFormat?.toLowerCase() == "rupees" ? ["totalSupplierCost", "tradeDiscount"] : ["totalSupplierCost"])?.includes(key)) {
            return true;
        }
        return false;
    }

    const isPercentage = (key) => {
        if ((responseData?.[0]?.tradeDiscountFormat?.toLowerCase() == "rupees" ? [] : ["tradeDiscount"])?.includes(key)) {
            return true;
        }
        return false;
    }

    // Function : To provide the current total supplier cost
    const getCurrentTotalSupplierCost = (type) => {
        let totalCost = 0;
        let unitCostKey = uType == "ENT" ? "retailerUnitCost" : "vendorUnitCost";
        tableData?.materialDets?.map(item => {
            totalCost += (Number(item?.[unitCostKey] || "") * Number(item?.["qty"] || ""));
        })
        return totalCost?.toFixed(2);
    }

    const getCurrentRowCostPercentage = (item) => {
        let unitCostKey = uType == "ENT" ? "retailerUnitCost" : "vendorUnitCost";
        return (Number((Number(item?.[unitCostKey] || "") * Number(item?.["qty"] || "")) / Number(getCurrentTotalSupplierCost("original") || "") || "") * 100)?.toFixed(2);
    }

    // Function: To combine the data based on the material type
    const getCostSheetDataCombinedByMaterialType = (data = []) => {
        let obj = {};

        tableData?.materialDets?.map(item => {
            if (!obj?.[item?.materialType]) {
                obj[item.materialType || ""] = {};
                obj[item.materialType || ""].data = [];
            }
            obj[item.materialType || ""].data.push(item);
            obj[item.materialType || ""]["vendorProposedCost"] = Number(obj[item.materialType || ""]?.["vendorProposedCost"] || 0) + Number(item?.vendorProposedCost || 0)
			obj[item.materialType || ""]["proposedCost"] = Number(obj[item.materialType || ""]?.["proposedCost"] || 0) + Number(item?.proposedCost || 0)
        })

        return obj;
    }

    // Function : To render the cost sheet details
    const renderCostsheetDetails = () => {

        let modifiedData = getCostSheetDataCombinedByMaterialType(tableData);

        let keys = ["materialName", "qty", "vendorUnitCost", "retailerUnitCost", "proposedCost", "percentage"];
        return <div className='dfvd-costsheet relative'>

            {/* Render the top level cost sheet details */}
            <div className='flex items-center gap-3'>
                <div className='dfvdc-det !top-[0px] !left-[5px]'>
                    {["costSheetName", "totalSupplierCost", "tradeDiscount", "tradeMargin", "marginType"]?.map(key => {
                        if (isDisplayKey(key)) {
                            return <div className='dfvdcd'>
                                <LanguageTranslator tag='label' className='!text-[11px] !font-medium !text-[#74767A] !mb-1'>{formSettings?.[key]?.["displayName"]}</LanguageTranslator>
                                <p className='rounded-[3px] min-w-[100px]'>{isAmount(key) && <span>&#8377;</span>} {tableData?.[key] || "-"} {isPercentage(key) && <span> % </span>}</p>
                            </div>
                        }
                    })}
                </div>

                {responseData?.length > 1 && uType == "ENT" && <div>
                    <GenericInput
                        value={currentCostSheet?.costSheetNo}
                        inputKey="costSheetNo"
                        iconRight={<Icons.DownArrowNew />}
                        customValue={() => currentCostSheet?.costSheetNo || ""}
                        type="dropdown"
                        label="Choose Costsheet"
                        inputProps={() => ({
                            headerKeys: {
                                "costSheetNo": "Costsheet No."
                            },
                            itemKeys: {
                                "costSheetNo": ["costSheetNo"],
                            },
                            getListData: () => responseData || [],
                        })}
                        onChange={(val) => {
                            setCurrentCostSheet(val);
                            setTableData(val);
                        }}
                    />
                </div>}
            </div>

            {/* Render the actual table for the costsheet */}
            <div className='px-[15px] mt-[70px] h-[calc(100%-80px)] overflow-auto'>
                {Object.keys(modifiedData || {})?.length == 0 && <div className='table-v2 !h-auto'>
                    <table>
                        <thead>
                            <tr>
                                {keys?.map((key, index) => (
                                    isDisplayKey(key) && <th key={`header-${index}`}><LanguageTranslator>{formSettings?.[key]?.displayName}</LanguageTranslator></th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className='!border-0'>
                            <tr>
                                <td colSpan='100' className='!border-0'>
                                    <LanguageTranslator tag='p' className='td-no-data'>No Data Found!</LanguageTranslator>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>}

                {
                    Object.keys(modifiedData || {})?.map((key, index) => {
                        return <div className={`table-v2 !h-auto ${Object.keys(modifiedData || {})?.length > 1 ? 'rounded-b-none last:rounded-[5px]' : ''} ${index > 0 ? '!border-t-0 !rounded-t-none' : ''}`}>
                            <table>
                                <thead>
                                    {index === 0 && <tr>
                                        {keys?.map((key, index) => (
                                            isDisplayKey(key) && <th key={`header-${index}`}><LanguageTranslator>{formSettings?.[key]?.displayName}</LanguageTranslator></th>
                                        ))}
                                    </tr>}
                                    <tr>
                                        <td colSpan={'100%'} className='px-3 h-[32px] align-middle'>
                                            <div className='flex justify-between items-center gap-3'>
                                                <p className='mb-0 text-xs font-semibold text-[#111D31]'>{key}</p>
                                                <div className='flex items-center gap-3'>
                                                    <div className='flex items-center gap-3'>
                                                        <div className='flex items-center gap-1'>
                                                            <Icons.VendorProposedCost />
                                                            <p className='mb-0 text-[11px] font-semibold text-[#6C6C6C]'>Total Vendor Proposed Cost : <span className='text-xs font-medium text-[#111D31]'>&#8377; {modifiedData?.[key]?.vendorProposedCost || "NA"}</span></p>
                                                        </div>
                                                        <div className='h-[10px] w-[1px] shrink-0 bg-borderSlateGrey'></div>
                                                        <div className='flex items-center gap-1'>
                                                            {/* <HandCoins size={14} color='#71819B' /> */}
                                                            <HandCoins size={14} color='#71819B' strokeWidth={1.75} />
                                                            <p className='mb-0 text-[11px] font-semibold text-[#6C6C6C]'>Total Retailed Proposed Cost : <span className='text-xs font-medium text-[#111D31]'>&#8377; {modifiedData?.[key]?.proposedCost || "NA"}</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        modifiedData?.[key]?.data?.map((item, index) => (
                                            <tr key={`row-${index}`} className='border-b border-r-borderSlateGrey last:border-b-0'>
                                                {keys?.map((key, subIndex) => (
                                                    isDisplayKey(key) && (
                                                        <td className='w-[calc(100%/6)]' key={`head-${subIndex}`}>
                                                            <label>{key == "percentage" ?
                                                                getCurrentRowCostPercentage(item)
                                                                : item?.[key]}
                                                            </label>
                                                        </td>
                                                    )
                                                ))}
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    })
                }
            </div>
        </div >
    }

    // Function : To render the custom cols 
    const renderCustomColumns = (key) => {
        {
            switch (key) {
                case "fabricComposition": {
                    return <div className='gvmb w-full'>
                        <LanguageTranslator tag='div' className='font-semibold'>{formSettings?.[key]?.displayName || ""}</LanguageTranslator>

                        {fabricFocusedRow?.[key]?.split('%')?.length == 0 ? <p style={{ marginRight: "10px" }}>-</p> : fabricFocusedRow?.[key]?.split('%')?.map(item => (
                            item && <p style={{ marginRight: "10px" }}>{item} %</p>
                        ))}
                    </div>
                }
                case "fabricColor": {
                    return <div className='gvmb'>
                        <LanguageTranslator tag='label' className='mb-0'>{formSettings?.[key]?.displayName || ""}</LanguageTranslator>
                        <p>{fabricFocusedRow?.["fabricColor"]?.name}</p>
                    </div>
                }
                case "constructionJson": {
                    return <div className='gvmb'>
                        <LanguageTranslator tag='label' className='mb-0'>{formSettings?.[key]?.displayName || ""}</LanguageTranslator>
                        <p>{JSON.parse(fabricFocusedRow?.[key] || "")}</p>
                    </div>
                }
                case "fabricDyeYarnCount":
                case "yarnCount": {
                    return <div className='gvmb w-full'>
                        <LanguageTranslator tag='label'>{formSettings?.[key]?.displayName || ""}</LanguageTranslator>
                        {typeof (fabricFocusedRow?.[key]) == "string" ? <p>{fabricFocusedRow?.[key]}</p> : <p>
                            {fabricFocusedRow?.[key]?.[0] ? fabricFocusedRow?.[key]?.[0] : ""}
                            {fabricFocusedRow?.[key]?.[1] ? " + " + fabricFocusedRow?.[key]?.[1] : ""}
                            {fabricFocusedRow?.[key]?.[2] ? " X " + fabricFocusedRow?.[key]?.[2] : ""}
                            {fabricFocusedRow?.[key]?.[3] ? " + " + fabricFocusedRow?.[key]?.[3] : ""}
                        </p>}
                    </div>
                }
                case "collection":
                case "size": {
                    return <div className='gvmb' >
                        <LanguageTranslator tag='label' className='mb-0'>{formSettings?.[key]?.displayName || ""}</LanguageTranslator>
                        <div className='flex flex-wrap'>
                            {tableData?.[key == "size" ? "libraryDet" : key]?.length == 0 ? <p>-</p> : tableData?.[key == "size" ? "libraryDet" : key]?.map(item => (
                                <p className='p-bg-grey'>{item?.[key == "size" ? "size" : "name"] || ""}</p>
                            ))}
                        </div>
                    </div>
                }
                case "color": {
                    return <div className='gvmb' >
                        <LanguageTranslator tag='label' className='mb-0'>{formSettings?.[key]?.displayName || ""}</LanguageTranslator>
                        <div className='flex flex-wrap'>
                            <p className='p-bg-grey'>{tableData?.["color"] || fabricFocusedRow?.["fabricColor"]?.name || ""}</p>
                        </div>
                    </div>
                }
                case 'vendorName': {
                    return <div className='gvmb w-full'>
                        <LanguageTranslator tag='label'>{formSettings?.[key]?.displayName || ""}</LanguageTranslator>
                        <div className='mt-[4px] flex items-center flex-wrap gap-3'>
                            {/* {formSettings?.[key]?.displayName || ""} */}
                            {
                                fabricFocusedRow?.["vendorJson"]?.map(item => (
                                    <p className='px-1 py-[2px] bg-[#ECECEC]'>{item?.["vendorName"] || "-"}</p>
                                ))
                            }
                        </div>
                    </div>
                }
            }
        }

    }

    console.log("sdfsfddsfdsfds", formSettings)

    // Function : To provide the view configuration
    const prepareViewConfiguration = (keys) => {
        let obj = {};
        // The fabric keys to render the data;
        keys?.map(key => {
            if (isDisplayKey(key)) {
                obj[key] = ["fabricDyeYarnCount", "constructionJson", "fabricColor", "yarnCount", "fabricComposition", "color", "size", "collection", "vendorName"]?.includes(key) ? () => renderCustomColumns(key) : formSettings?.[key]?.displayName || "";
            }
        });
        return obj;
    }

    // Function : To render the fabric details 
    const renderFabricDetails = () => {
        if (tableData?.length == 0) {
            return <div className='dfvb-det'>
                <NoDataFound primaryText="No Fabrics Found!" />
            </div>
        }

        let fabricKeys = prepareViewConfiguration(Object.keys(formSettings || {}));

        return (
            <div className='dfvb-det'>
                <div className='dfvbd-fabric'>
                    {tableData?.map(item => (
                        <div className='dfvbdf-det' onClick={() => setFabricFocusedRow(item)}>
                            <div className='frd-top'>
                                <div className='flex items-center'>
                                    {item?.fabricImageUrl ?
                                        <div className='frdt-img'>
                                            <img src={item?.fabricImageUrl} />
                                        </div> :
                                        <div className='frdt-img'>
                                            <Icons.ImageThumbnail />
                                        </div>
                                    }
                                    <div className='p-lft-10'>
                                        <label>Fabric Code</label>
                                        <p>{item?.fabricCode || ""}</p>
                                    </div>
                                </div>
                                {/* Render the expand collapse toggle button */}
                                <GenericCustomButton
                                    label={expandedFabric?.id === item?.id ? "Collapse Details" : "Expand For Details"}
                                    rightIcon={<Icons.DownArrowNew className={expandedFabric?.id === item?.id && "rotate-180"} />}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (item?.id === expandedFabric?.id) {
                                            setExpandedFabric(null);
                                        } else {
                                            setExpandedFabric(item);
                                            setFabricFocusedRow(item);
                                        }
                                    }}
                                />
                            </div>
                            <div className='frd-bot flex items-start justify-between'>
                                <p>{item?.fabricName}</p>
                                <CopyContentGenericComponent type={2} content={item?.fabricName} />
                            </div>
                            {/* Place to render the expanded details for the fabric row */}
                            {expandedFabric?.id === item?.id && (
                                <div className='dfvbdf-data'>
                                    <GenericViewDetailsComponent
                                        label=""
                                        sections={{
                                            basicDetails: "",
                                        }}
                                        headerKeys={{
                                            "basicDetails": {
                                                "numOfCols": 1,
                                                "keys": fabricKeys,
                                            }
                                        }}
                                        selectedData={fabricFocusedRow}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Render the image section here */}
                <div className={`dfvbd-right ${viewPageType === 'fabric' ? '!pt-[76px]' : ''}`}>
                    {renderImageSection()}
                </div>
            </div>
        )
    }

    // Function : To render the product details
    const renderProductDetails = () => {
        let basicKeys = ["hl1Name", "hl2Name", "hl3Name", "designGroupNumber", "season", "itemName", "color", "size", "description", "costPrice"];
        let basicDetailsKeys = prepareViewConfiguration(basicKeys);
        let attributeKeys = Object.keys(formSettings || {})?.filter(key => !basicKeys?.includes(key));
        let attributeDetailsKeys = prepareViewConfiguration(attributeKeys);


        return <div className='dfvb-det'>
            <div className='dfvbd-left'>
                <GenericViewDetailsComponent
                    label=""
                    sections={{
                        basicDetails: "BASIC DETAILS",
                        attributes: "ATTRIBUTES"
                    }}
                    headerKeys={{
                        "basicDetails": {
                            "numOfCols": 1,
                            "keys": basicDetailsKeys,
                        },
                        "attributes": {
                            "numOfCols": 1,
                            "keys": attributeDetailsKeys,
                        }
                    }}
                    selectedData={tableData}
                />
            </div>
            <div className='dfvbd-right'>
                {renderImageSection()}
            </div>
        </div>
    }

    // Function : To render the custom attributes tab 
    const renderCustomAttributes = () => {
        return <div className='dfvb-det'>
            <div className='dfvbd-left'>
                <div className='generic-view-modal'>
                    <div className='gvm-scroll'>
                        <div className='gvm-body'>
                            {Object.keys(headersData || {}).length > 0 && Object.keys(headersData?.[headersType] || {})?.map(key => (
                                <div className='gvmb' key={key}>
                                    <label>{headersData[headersType][key]}</label>
                                    <p>{tableData?.[0]?.[key] || "0"}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className='dfvbd-right'>
                {renderImageSection()}
            </div>
        </div>
    }

    // Function : To render the image section for the product and fabric
    const renderImageSection = () => {
        console.log("Image data", imagesData);
        return <ImageUpload
            module={currentTab == "customAttributes" ? "product" : currentTab}
            viewOnly={true}
            setMediaData={setImagesData}
            mediaData={imagesData}

            formSettings={formSettings}
            displayKey={displayKey}
        />
    }

    // Function : To reset all the current states
    const resetStates = () => {
        setTableData(null);
        setFormSettings({});
        setImagesData(null);
        setFabricFocusedRow(null);
        setExpandedFabric(null);
    }

    const changeTab = (val) => {
        resetStates();
        setCurrentTab(val);
    }

    let parseToken = parseJwt(sessionStorage.getItem('token')), deleteRowOnTheseIds = ["8534", "754"];

    // Function : To render the tabs 
    const renderTabsSection = () => {
        return (
            <div className='dfvb-radio'>
                <Radio.Group value={currentTab} onChange={(e) => changeTab(e?.target?.value)}>
                    <Radio.Button value={"product"}><LanguageTranslator>Product Details</LanguageTranslator></Radio.Button>
                    <Radio.Button value={"fabric"}><LanguageTranslator>Fabric</LanguageTranslator></Radio.Button>
                    <Radio.Button value={"costsheet"}><LanguageTranslator>Costsheet</LanguageTranslator></Radio.Button>
                    {/* {deleteRowOnTheseIds?.includes(parseToken?.schemaEntID) && <Radio.Button value={"customAttributes"}><LanguageTranslator>Custom Attributes</LanguageTranslator></Radio.Button>} */}
                </Radio.Group>
            </div>
        )
    }

    return (
        <div className='df-view-img viewProductDetails'>
            {renderHeaderComponent()}

            {/* Render the content of view details in two portion */}
            <div className='dfv-body'>
                {/* Render the details section */}
                <div className='h-100'>
                    {/* Render tabs */}
                    {viewPageType == "product" && renderTabsSection()}

                    {renderDetails()}
                </div>
                {/* render the image section */}
                {["product", "fabric"]?.includes(currentTab) && <div>

                </div>}
            </div>
        </div>
    )
}

export default ViewProductDetails